import React from "react";
import AdminsContainer from "../../modules/Admins/containers/AdminsContainer/AdminsContainer";

const Admins = () => {
  return <AdminsContainer />;
};

export default Admins;
